module.exports = __webpack_public_path__ + "media/images/undraw/online_payments-7660231233e1c13eebb7325aaccb3e2e.png";